import { render, staticRenderFns } from "./DocumentTabs.vue?vue&type=template&id=68133799&scoped=true"
import script from "./DocumentTabs.vue?vue&type=script&lang=js"
export * from "./DocumentTabs.vue?vue&type=script&lang=js"
import style0 from "./DocumentTabs.vue?vue&type=style&index=0&id=68133799&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68133799",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AlturaWindow: require('/app/node_modules/@altura/components/components/Window.vue').default,AlturaSpinner: require('/app/node_modules/@altura/components/components/Spinner.vue').default,AlturaButton: require('/app/node_modules/@altura/components/components/Button.vue').default,AlturaCollapse: require('/app/node_modules/@altura/components/components/Collapse.vue').default,AlturaTab: require('/app/node_modules/@altura/components/components/tabs/Tab.vue').default,DetailDocumentChat: require('/app/components/detail/DocumentChat.vue').default,AlturaTabContainer: require('/app/node_modules/@altura/components/components/tabs/TabContainer.vue').default,AlturaContainer: require('/app/node_modules/@altura/components/components/Container.vue').default})
